export default [
    {
        path: "/admin/cadres",
        component: () => import("../Components/List.vue"),
        name: "cadres-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/cadres/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "cadres-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/cadres/create",
        component: () => import("../Components/Create.vue"),
        name: "cadres-create",
        meta: {
            requiresAuth: true,
        },
    },
];
